import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { Users, Upload, Sliders, MonitorSpeaker, Wrench, Smartphone } from 'lucide-react'

/* Image Compo-navigatie — één tabstrip, rol-gefilterd.
   Analogisch aan KempenvisionNav zodat de twee shows dezelfde structuur
   krijgen; sidebar houdt maar 1 top-level Imagecompo-link. */

const TABS = [
  { path: '/imagecompo',           label: 'Publiek',   icon: Users,          public: true },
  { path: '/imagecompo/inleveren', label: 'Inleveren', icon: Upload,         public: true },
  { path: '/imagecompo/control',   label: 'Regie',     icon: Sliders,        adminOrReferee: true },
  { path: '/imagecompo/touch',     label: 'Touch',     icon: Smartphone,     adminOrReferee: true },
  { path: '/imagecompo/midi',      label: 'MIDI',      icon: MonitorSpeaker, admin: true },
  { path: '/imagecompo/admin',     label: 'Setup',     icon: Wrench,         admin: true },
]

export default function ImagecompoNav() {
  const { user } = useAuth()
  const location = useLocation()
  const role = user?.role
  const isAdmin = role === 'admin' || role === 'superadmin'
  const isReferee = role === 'referee' || isAdmin

  const visible = TABS.filter(t => {
    if (t.public) return true
    if (t.admin) return isAdmin
    if (t.adminOrReferee) return isReferee
    return false
  })

  return (
    <div className="border-b border-border mb-4">
      <div className="flex gap-1 overflow-x-auto -mb-px px-4 pt-2">
        {visible.map(tab => {
          const Icon = tab.icon
          const active = location.pathname === tab.path
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`flex items-center gap-1.5 px-3 py-2 text-sm border-b-2 whitespace-nowrap transition-colors ${
                active
                  ? 'border-primary text-foreground'
                  : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
              }`}
            >
              <Icon size={14} /> {tab.label}
            </Link>
          )
        })}
      </div>
    </div>
  )
}
